import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { ConnectPage } from 'src/app/model/page/connect-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-connect-page',
  templateUrl: './connect-page.component.html',
  styleUrls: ['./connect-page.component.scss']
})
export class ConnectPageComponent implements OnInit {
  connectPage: ConnectPage = {} as ConnectPage;
  constructor(private contentfulService: ContentfulService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'connect') {
        this.connectPage.htmlTitle = title.htmlTitle;
      }
    });
    this.connectPage.connectCard = [];
    const query = { 'fields.title': 'CONNECT' };
    this.contentfulService.getPageContentResponse(query).then((connectPageEntries) => {
      this.mapBanner(connectPageEntries.includes.Entry);
      this.mapCards(connectPageEntries.includes.Entry);
      this.mapHtmlTitle(connectPageEntries.items);
    });
  }

  private mapBanner(connectPageEntries: Entry<any>[]) {
    connectPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let image: any = entry.fields['image'];
    let video: any = entry.fields['video'];
    this.connectPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: image.fields.file.url,
      video: video?.fields?.file?.url
    };
  }

  private mapCards(connectPageEntries: any[]) {
    connectPageEntries
      .filter((entry) => ModelValidator.isCard(entry))
      .forEach((entry) => {
        this.mapEntryToconnectCards(entry);
      });

    this.connectPage.connectCard.sort((a, b) => a.order - b.order);
  }

  private mapEntryToconnectCards(entry: Entry<any>) {
    let headImage: any = entry.fields['headImage'];
    this.connectPage.connectCard.push({
      title: entry.fields['title'] as string,
      headImage: headImage.fields?.file?.url,
      order: entry.fields['order'] as number,
      titleLink: '',
      richTextBody: entry.fields['body'] as string
    });
  }

  private mapHtmlTitle(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      this.connectPage.htmlTitle = entry.fields.htmlTitle;
    });
  }
}
